<script lang="ts">
	import { PortableText } from '@portabletext/svelte';
	import BlankedLink from 'components/LearnPage/BlankedLink/BlankedLink.svelte';

	export let portableText;
	$: dark = portableText?.global?.context?.dark;

	$: ({ value } = portableText);
</script>

<ul class="faq-wrapper" itemscope itemtype="https://schema.org/FAQPage" class:dark>
	{#each value.list as item}
		<li itemscope class="faq-item" itemtype="https://schema.org/Question">
			<h3 class="question" itemprop="name">{item?.faqQuestion[0]?.children[0]?.text.slice(4)}</h3>
			<div class="answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
				<div itemprop="text">
					{#each item?.faqAnswer as answer}
						<PortableText
							value={answer}
							components={{
								marks: {
									link: BlankedLink,
								},
							}}
						/>
					{/each}
				</div>
			</div>
		</li>
	{/each}
	</ul>

<style lang="scss">
	@import 'sanityFAQ';
</style>
